import { AxiosPromise } from 'axios';
import { IDeleteGroupMemberLinkCommand } from './types';
import { instance } from '../../../../../../services/api';

export default (data: IDeleteGroupMemberLinkCommand): AxiosPromise =>
  instance.post('api/localGroupMemberDetails/groupMemberLinks/delete', data);
